import * as React from 'react';
import { Button, Input, Icons } from 'src/components';

interface ISearchProps {
  value: string;
  isSearching?: boolean;
  onChange: (term: string) => void;
  onSubmit: () => void;
}
class Search extends React.Component<ISearchProps> {
  onChange = (event: React.SyntheticEvent<HTMLInputElement>) => {
    this.props.onChange(event.currentTarget.value);
  };

  onSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    this.props.onSubmit();
  };

  render() {
    const { isSearching } = this.props;
    return (
      <form
        onSubmit={this.onSubmit}
        className="flex w-1/2 pt-8 pb-12 mx-auto text-xl"
      >
        <Input
          className="flex-1 mr-4"
          name="search"
          secondary={true}
          autoComplete="off"
          value={this.props.value}
          onChange={this.onChange}
        />
        <Button
          className="flex items-center leading-default"
          type="submit"
          loading={isSearching}
        >
          <Icons.Search className="mr-4" />
          {this.props.isSearching ? 'Searching' : 'Search'}
        </Button>
      </form>
    );
  }
}

export default Search;



// WEBPACK FOOTER //
// ./src/views/Links/components/Search.tsx